var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPatientConsentDeleteIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1.5,
    width: 28,
    height: 25,
    rx: 4,
    fill: "#EFEFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 13.25V17.75",
    stroke: "#E15554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.25V17.75",
    stroke: "#E15554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.25H20",
    stroke: "#E15554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.25H14H18.5V18.5C18.5 19.7427 17.4927 20.75 16.25 20.75H11.75C10.5074 20.75 9.5 19.7427 9.5 18.5V10.25Z",
    stroke: "#E15554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.75C11.75 7.92157 12.4216 7.25 13.25 7.25H14.75C15.5784 7.25 16.25 7.92157 16.25 8.75V10.25H11.75V8.75Z",
    stroke: "#E15554",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPatientConsentDeleteIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Patient_Consent_Delete_Icon.18984af1.svg";
export { ForwardRef as ReactComponent };